import { Component, Input, OnInit } from '@angular/core';
import { ShapeService } from '../../../shape/shape.service';

@Component({
  selector: 'nw-spacing-controller',
  templateUrl: './spacing-controller.component.html',
  styleUrls: ['./spacing-controller.component.scss'],
})
export class SpacingControllerComponent implements OnInit {
  get isRow() {
    return this.shapeService.selectionAlignType == 'row';
  }

  get isColumn() {
    return this.shapeService.selectionAlignType == 'column';
  }

  @Input()
  alignment = false;
  showRightInput = false;
  showBottomInput = false;

  gap: number;
  get rightX() {
    const { x, width } = this.shapeService.multiShapeSelectRCRelativeBBox;
    return x + width + 12;
  }

  get rightY() {
    const { y, height } = this.shapeService.multiShapeSelectRCRelativeBBox;
    return y + height / 2;
  }

  get bottomX() {
    const { x, width } = this.shapeService.multiShapeSelectRCRelativeBBox;
    return x + width / 2;
  }

  get bottomY() {
    const { y, height } = this.shapeService.multiShapeSelectRCRelativeBBox;
    return y + height + 12;
  }

  constructor(public readonly shapeService: ShapeService) {}

  ngOnInit(): void {
    // -- // console.log('spacing-controller > onInit'); // -- //
  }

  rowGap: number;
  rowClicked = false;
  evenAlignRow() {
    this.gap = this.shapeService.evenAlignRow();
    this.showBottomInput = true;
    this.rowClicked = true;
  }
  columnGap: number;
  evenAlignColumn() {
    this.gap = this.shapeService.evenAlignColumn();
    this.showBottomInput = false;
    this.rowClicked = true;
  }
  gapChange() {
    if (this.isRow) {
      this.shapeService.evenAlignRow(this.gap);
    } else {
      this.shapeService.evenAlignColumn(this.gap);
    }
  }

  dragging = false;
  startX = 0;
  startY = 0;
  originalGap = 0;
  dragDirection: 'horizontal' | 'vertical';
  onDragStart(event: MouseEvent, direction: 'horizontal' | 'vertical') {
    console.log('on-drag-start');
    if (!this.shapeService.evenGap) {
      return;
    }

    this.dragDirection = direction;
    this.dragging = true;
    this.startX = event.clientX;
    this.startY = event.clientY;
    this.originalGap = this.shapeService.evenGap;

    window.addEventListener('mousemove', this.onDragging);
    window.addEventListener('mouseup', this.onDragEnd);
  }

  onDragging = (event: MouseEvent) => {
    if (!this.dragging) return;

    let delta: number;
    if (this.dragDirection == 'vertical') {
      delta = event.clientY - this.startY;
    } else {
      delta = event.clientX - this.startX;
    }
    const newGap = this.originalGap + Math.round(delta / 2);
    this.gap = Math.max(0, newGap);
    this.gapChange();
  };

  onDragEnd = () => {
    this.dragging = false;
    this.shapeService.evenGap = this.gap;
    window.removeEventListener('mousemove', this.onDragging);
    window.removeEventListener('mouseup', this.onDragEnd);
  };
}
